import { Navigate, useLocation } from 'react-router-dom';
import { useUserContext } from '../hooks/useUserContext';

/**
 * Sends new users into the CPE onboarding wizard until they finish or skip it
 * (persisted as onboardingCompletedAt on the backend profile). Captures the
 * originally requested location so the wizard can resume it after skip. Fails
 * open when the profile fetch failed (backendProfile == null).
 */
export default function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { backendProfile, loading } = useUserContext();
  const location = useLocation();
  const needsOnboarding =
    !loading && backendProfile != null && backendProfile.onboardingCompletedAt == null;
  if (needsOnboarding && location.pathname !== '/app/onboarding') {
    return (
      <Navigate
        to="/app/onboarding"
        replace
        state={{ resumeTo: { pathname: location.pathname, state: location.state } }}
      />
    );
  }
  return <>{children}</>;
}
